<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">CONTACT</h3>
    <div class="informationDetail">
      <div>
        <h4>Cardhobby Germany GmbH</h4>
        <div>Luisenstraße 9</div>
        <div>40215 Düsseldorf</div>
        <div>Germany</div>
      </div>
      <div>
        <h4>Contact:</h4>
        <div>Phone: +49 17643383156</div>
        <div>Email: infode@cardhobby.com</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  created() {},
  methods: {}
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";

.informationDetail h4{
  font-weight: 700;
  font-size: 16px;
}
.informationDetail>div{
  line-height: 1.5;
}
.informationDetail>div+div{
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/information/about.vue